module.exports = __webpack_public_path__ + "img/mainRuleText.4316061d.png";